import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import FluidImageWrapper from '../FluidImageWrapper';
import ImageFluid from '../ImageFluid';
import Text from '../Text';
import Link from '../Link';
import { PINK, WHITE } from '../../../constants/colors';
import Styles from './PromotionItem.styles';

const Wrapper = styled.a`${Styles.wrapper}`; // prettier-ignore
const ItemWrapper = styled.div`${Styles.itemWrapper}`; // prettier-ignore
const Title = styled(Text)`${Styles.title}`; // prettier-ignore
const Description = styled(Text)`${Styles.description}`; // prettier-ignore
const Terms = styled(Text)`${Styles.terms}`; // prettier-ignore
const CallToActionWrapper = styled.div`${Styles.callToActionWrapper}`; // prettier-ignore
const CallToAction = styled(Link)`${Styles.callToAction}`; // prettier-ignore
const More = styled.a`${Styles.more}`;
const Transparentbg = styled.div`
  ${Styles.transparentbg};
`;
const Pinkbg = styled.div`
  ${Styles.pinkbg};
`;


/**
 * PromotionItem component
 * @property {string} title - promo title
 * @property {string} description - promo description
 * @property {string} descriptionColor - promo description color
 * @property {string} titleColor - promo title color
 * @property {string} termsColor - promo terms color
 * @property {string} terms - promo terms
 * @property {string} callToAction - promo call to action text
 * @property {string} link - call to action link
 * @property {boolean} innerLink - true if the link is internal
 * @returns {JSX.Element}
 */
const PromotionItem = ({
  title,
  description,
  descriptionColor,
  titleColor,
  termsColor,
  terms,
  callToAction,
  link,
  innerLink,
  backgroundImage
}) => (
  <Wrapper target="_blank" href={link === '' ? null : link}>
    <Transparentbg />
    <Pinkbg />
    <ItemWrapper>
      <Title tag="h4" className="col-sm-6" descriptionColor={titleColor} bold>
        {title}
      </Title>
    </ItemWrapper>
    <ItemWrapper>
      <Description tag="p" descriptionColor={descriptionColor} className="col-sm-6">
        {description}
      </Description>
    </ItemWrapper>
    <ItemWrapper>
      <Terms tag="p" descriptionColor={termsColor} className="col-sm-6">
        {terms}
      </Terms>
    </ItemWrapper>
    <ItemWrapper>
      <More href={link} preloadDisabled={!innerLink}>+</More>
    </ItemWrapper>
    <CallToActionWrapper className="col-sm-6">
      <CallToAction href={link} className="cbx-bold" preloadDisabled={!innerLink}>
        {callToAction}
      </CallToAction>
    </CallToActionWrapper>
    <FluidImageWrapper>
      <ImageFluid fluid={backgroundImage} imgStyle={{ height: 'auto' }} />
    </FluidImageWrapper>
  </Wrapper>
);

PromotionItem.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  descriptionColor: PropTypes.string,
  titleColor: PropTypes.string,
  termsColor: PropTypes.string,
  terms: PropTypes.string,
  callToAction: PropTypes.string,
  link: PropTypes.string,
  innerLink: PropTypes.bool,
  backgroundImage: PropTypes.object
};

PromotionItem.defaultProps = {
  descriptionColor: PINK,
  termsColor: WHITE,
  titleColor: WHITE,
  innerLink: false
};

export default PromotionItem;
